import { Button, ButtonText } from '@/components/ui/button'
import { BoxIcon } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuItemIndicator,
  DropdownMenuRadioGroup,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu'
import {
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
} from '@/components/ui/DropdownMenu'
import React from 'react'

export default function DropDownMenuDemo() {
  const [person, setPerson] = React.useState('pedro')
  const [firstChecked, setFirstChecked] = React.useState(true)
  const [secondChecked, setSecondChecked] = React.useState(true)

  return (
    <div>
      <h2>Dropdown Menu</h2>
      <div className="h- flex  flex-wrap gap-3 ">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Button>
              <ButtonText>Dropdown Menu</ButtonText>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <DropdownMenuItemIndicator>
                <BoxIcon />
              </DropdownMenuItemIndicator>
              Item 1
            </DropdownMenuItem>
            <DropdownMenuItem>
              <DropdownMenuItemIndicator>
                <BoxIcon />
              </DropdownMenuItemIndicator>
              Item 2
            </DropdownMenuItem>
            <DropdownMenuSeparator />

            <DropdownMenuRadioGroup value={person} onValueChange={setPerson}>
              <DropdownMenuRadioItem value={'pedro'}>
                Pedro
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value={'maria'}>
                Maria
              </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
            <DropdownMenuSeparator />
            <DropdownMenuCheckboxItem
              checked={firstChecked}
              onCheckedChange={setFirstChecked}
            >
              Checkbox 1
            </DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem
              checked={secondChecked}
              onCheckedChange={setSecondChecked}
            >
              Checkbox 2
            </DropdownMenuCheckboxItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  )
}
